/*
  Merqelo product search (sections/mq-product-search.liquid).
  Filter, sort and page links load the section in place through Shopify's Section Rendering API
  and update the address bar; without JavaScript they are ordinary links and a GET form.
  Also: the filter drawer, one-at-a-time filter dropdowns and "Show more" on long lists.
*/
(function () {
  'use strict';

  if (window.__mqSearch) return;
  window.__mqSearch = true;

  var MORE_LABEL = 'Show more';
  var LESS_LABEL = 'Show less';
  var controller = null;

  function root() {
    return document.querySelector('[data-mq-search]');
  }

  function sectionElement(search) {
    return search ? search.closest('.shopify-section') : null;
  }

  /* ---------- Loading results in place ---------- */

  function load(url, options) {
    var search = root();
    var wrapper = sectionElement(search);
    if (!search || !wrapper) {
      window.location.href = url;
      return;
    }
    var opts = options || {};
    var drawer = search.querySelector('[data-mq-drawer]');
    var drawerOpen = !!(drawer && drawer.open);
    var target = new URL(url, window.location.origin);
    var fetchUrl = new URL(target.href);
    fetchUrl.searchParams.set('section_id', search.getAttribute('data-section'));

    if (controller) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;
    search.classList.add('is-loading');

    fetch(fetchUrl.href, { signal: controller ? controller.signal : undefined, credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-mq-search]');
        if (!fresh) throw new Error('Section not found');
        var freshWrapper = fresh.closest('.shopify-section') || fresh;
        wrapper.innerHTML = freshWrapper.innerHTML;
        if (opts.push !== false) {
          window.history.pushState({ mqSearch: true }, '', target.pathname + target.search);
        }
        var next = root();
        init(next);
        if (drawerOpen) {
          var nextDrawer = next.querySelector('[data-mq-drawer]');
          if (nextDrawer && nextDrawer.showModal) nextDrawer.showModal();
        }
        if (opts.scroll) {
          var top = next.getBoundingClientRect().top + window.scrollY - 120;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        }
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        window.location.href = target.href;
      });
  }

  window.addEventListener('popstate', function () {
    if (root()) load(window.location.href, { push: false });
  });

  /* ---------- Wiring ---------- */

  function closePops(search, except) {
    search.querySelectorAll('.mq-pop[open]').forEach(function (pop) {
      if (pop !== except) pop.removeAttribute('open');
    });
  }

  function collapseLists(search) {
    search.querySelectorAll('[data-mq-more]').forEach(function (list) {
      var limit = parseInt(list.getAttribute('data-mq-more'), 10) || 8;
      var items = Array.prototype.slice.call(list.children);
      if (items.length <= limit + 1) return;
      var extra = items.slice(limit);
      var hasActive = extra.some(function (item) {
        return item.querySelector('.is-on, .is-current');
      });
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'mq-more-toggle';
      button.setAttribute('aria-expanded', 'false');

      function set(open) {
        extra.forEach(function (item) { item.hidden = !open; });
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        button.innerHTML = (open ? LESS_LABEL : MORE_LABEL) +
          '<svg viewBox="0 0 20 20" width="14" height="14" aria-hidden="true" focusable="false" style="transform:rotate(' + (open ? 180 : 0) + 'deg)"><path d="M5.5 8l4.5 4.5L14.5 8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      }

      button.addEventListener('click', function () {
        set(button.getAttribute('aria-expanded') !== 'true');
      });
      set(hasActive);
      list.insertAdjacentElement('afterend', button);
    });
  }

  function init(search) {
    if (!search || search.__mqReady) return;
    search.__mqReady = true;

    collapseLists(search);

    search.addEventListener('click', function (event) {
      var link = event.target.closest('a[data-mq-link]');
      if (link && search.contains(link)) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
        event.preventDefault();
        load(link.href, { scroll: link.hasAttribute('data-mq-scroll') });
        return;
      }
      if (event.target.closest('[data-mq-drawer-open]')) {
        var drawer = search.querySelector('[data-mq-drawer]');
        if (drawer && drawer.showModal) {
          closePops(search);
          drawer.showModal();
        }
        return;
      }
      if (event.target.closest('[data-mq-drawer-close]')) {
        var open = search.querySelector('[data-mq-drawer][open]');
        if (open) open.close();
        return;
      }
      var dialog = event.target.closest('[data-mq-drawer]');
      if (dialog && event.target === dialog) dialog.close();
    });

    search.querySelectorAll('.mq-pop').forEach(function (pop) {
      pop.addEventListener('toggle', function () {
        if (pop.open) closePops(search, pop);
      });
    });

    var sort = search.querySelector('[data-mq-sort]');
    if (sort) {
      var select = sort.querySelector('select');
      if (select) {
        select.addEventListener('change', function () {
          if (sort.requestSubmit) sort.requestSubmit();
          else sort.dispatchEvent(new Event('submit', { cancelable: true }));
        });
      }
      sort.addEventListener('submit', function (event) {
        event.preventDefault();
        var params = new URLSearchParams(new FormData(sort));
        load(sort.getAttribute('action') + '?' + params.toString());
      });
    }
  }

  document.addEventListener('click', function (event) {
    var search = root();
    if (search && !event.target.closest('.mq-pop')) closePops(search);
  });

  document.addEventListener('keydown', function (event) {
    var search = root();
    if (event.key === 'Escape' && search) {
      var open = search.querySelector('.mq-pop[open]');
      if (open) {
        open.removeAttribute('open');
        var summary = open.querySelector('summary');
        if (summary) summary.focus();
      }
    }
  });

  function boot() {
    init(root());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    boot();
  });
})();
